export const formatAmount = amount =>
  (amount || amount === 0) && amount.toFixed(2);



// WEBPACK FOOTER //
// ./src/utils/appointments/formatAmount.js